module.exports = __webpack_public_path__ + "static/safari-f3999aa04ef25bd7037aca699cc109c3.png";